//natives
import React, { Component } from 'react';
import Timeline, {
    TimelineHeaders,
    SidebarHeader,
    DateHeader,
    CustomHeader,
    TimelineMarkers,
    TodayMarker,
    CustomMarker,
    CursorMarker
} from 'react-calendar-timeline';
import 'react-calendar-timeline/lib/Timeline.css';
import moment from 'moment';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Button from '@material-ui/core/Button';

import ModalConfirmacao from '../../ModalConfirmacao/.mixins/ModalConfirmacao';

export default class TabelaDinamica extends Component {
    
    constructor(props) {
        super(props);

        this.state = {
            groups: [],
            items: [],
            open: false,
            mensagem: '',
            contador: 0,
            id_marc_global: 0,
            defaultTimeStart: moment().hour(0).add(-12, 'day'),
            defaultTimeEnd: moment().hour(0).add(12, 'day'),
            visibleTimeStart: moment().hour(0).add(-12, 'day').valueOf(),
            visibleTimeEnd: moment().hour(0).add(12, 'day').valueOf(),
            disableButtons: {
                previous: false,
                next: false,
            },
            isInteractingWithItemTable: true,
            scrolling: true
        };

        //binds
        this.setState = this.setState.bind(this);
        this.handleClickOpen = this.handleClickOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);
        this.removeDataDispCalendar = this.removeDataDispCalendar.bind(this);
        this.setaDataDispCalendar = this.setaDataDispCalendar.bind(this);
        this.addDataAgendada = this.addDataAgendada.bind(this);
        this.leitorDatas = this.leitorDatas.bind(this);
        this.itemRenderer = this.itemRenderer.bind(this);
        this.render = this.render.bind(this);
        this.animateScroll = this.animateScroll.bind(this);
        this.onPrevClick = this.onPrevClick.bind(this);
        this.onNextClick = this.onNextClick.bind(this);
        
    }

    handleClickOpen(mensagem) {
        this.setState({open: true, mensagem: mensagem});
    };

    /* handleClose() {
        this.setState({open: false});
    }; */

    handleClose() {
        this.setState({open: false});
        if (this.props.state.itemEscolhido && this.props.state.itemEscolhido.tipo != 4) {
            this.pintarDeselecionada();
        }
    };

    pintarDeselecionada() {
        var itemsTemp = [];
        this.state.items.forEach(element => {
            if (element.group == this.props.state.itemEscolhido.group && element.id == this.props.state.itemEscolhido.id) {
                element.bgColor = 'rgb(226, 239, 217)';
                element.selectedBgColor = '#E2EFD9';
            }
            itemsTemp.push(element);
        });
        this.setState({items: itemsTemp});
    };

    pintarSelecionada() {
        var itemsTemp = [];
        this.state.items.forEach(element => {
            if (element.group == this.props.state.itemEscolhido.group && element.id == this.props.state.itemEscolhido.id) {
                //element.bgColor = '#07533E';
                element.selectedBgColor = '#07533E';
            }
            itemsTemp.push(element);
        });
        this.setState({items: itemsTemp});
    };

    async handleConfirm() {
        this.pintarSelecionada();
        this.setState({open: false});
        if (this.props.state.itemEscolhido.tipo == 4) {
            this.removeDataDispCalendar(this.props.state.itemEscolhido.id);
            this.pintarDeselecionada()
        } else if (await this.containsInAgendados(this.props.state.itemEscolhido.group)) {
            var list = await this.getAgendadosExcepID(this.props.state.itemEscolhido.group);
            this.props.setState({datasAgendadas: list});
            var newItems = await this.atualizaTela(this.props.state.itemEscolhido.group);
            this.setState({items: newItems});
            this.setaDataDispCalendar(this.props.state.itemEscolhido.id);
            this.addDataAgendada();
        } else {
            this.setaDataDispCalendar(this.props.state.itemEscolhido.id);
            this.addDataAgendada();
        }
        window.datasAgendadas = this.props.state.datasAgendadas;
    };

    atualizaTela(id) {
        return new Promise((resolve,reject)=>{
            var itemsTemp = [];
            this.state.items.forEach(element => {
                if (element.group == id && element.tipo == 4) {
                    element.bgColor = '#E2EFD9';
                    element.selectedBgColor = '#07533E';
                    element.tipo = 1;
                    itemsTemp.push(element);
                } else {
                    itemsTemp.push(element);
                }
            });
            resolve(itemsTemp);
        });
    }

    getAgendadosExcepID(id) {
        return new Promise((resolve,reject)=>{
            var list = [];
            this.props.state.datasAgendadas.forEach(e => {
                if (e.idGroup != id)
                    list.push(e);
            });
            resolve(list);
        });
    }

    containsInAgendados(id) {
        return new Promise((resolve,reject)=>{
            this.props.state.datasAgendadas.forEach(e => {
                if (e.idGroup == id)
                    resolve(true);
            });
            resolve(false);
        });
    }

    addDataAgendada() {
        var array = this.props.state.datasAgendadas;
        var i = this.props.state.itemEscolhido.group;
        var datas = this.leitorDatas(this.props.state.itens[i].availableScheduleDatesList);
        var ccaf = null;
        
        datas.forEach(element => {
            if (this.props.state.itemEscolhido.start_time.format('DD/MM/YY') == element.data) {
                ccaf = element.id;
            }
        });

        if (ccaf == null)
            return this.props.child.current.retorno('Erro ao carregar dados!','error');

        array.push({
            Dt_agenda: this.props.state.itemEscolhido.start_time.format('DD/MM/YYYY'),
            Cd_fil: this.props.state.itens[i].branchId,
            Nr_pc: this.props.state.itens[i].purchaseOrderId,
            Id_prod: this.props.state.itens[i].productId,
            Dt_entrg: this.props.state.itens[i].deliveryDate,
            Qt_vol: this.props.state.itens[i].amountOutstandingVolume,
            Qt_age: this.props.state.itens[i].quantityOutstanding,
            //Colocar para testar retorno de pedidos com falha
            /* Qt_vol: 50000,
            Qt_age: 50000, */
            Id_ccaf: ccaf,
            In_tipo_ped: this.props.state.itens[i].orderType,
            idMarc: this.props.state.itemEscolhido.id,
            idGroup: i
        });
        this.props.setState({datasAgendadas: array});
    }

    setaDataDispCalendar(id) {
        var temp = this.state.items;
        temp.forEach(element => {
            if (element.id == id) {
                element.bgColor = 'rgb(7, 83, 62)';
                element.selectedBgColor = '#07533E';
                element.tipo = 4;
            }
        });
        this.setState({items: temp});
    }

    removeDataDispCalendar(id) {
        //remove da tela
        var itemsTemp = this.state.items;
        itemsTemp.forEach(element => {
            if (element.id == id) {
                element.bgColor = 'rgb(7, 83, 62)';
                element.selectedBgColor = '#07533E';
                element.tipo = 1;
            }
        });
        this.setState({items: itemsTemp});

        //atualiza no vetor principal
        var datasAgendadasTemp = [];
        this.props.state.datasAgendadas.forEach(element => {
            if (!(element.idMarc == id)) {
                datasAgendadasTemp.push(element);
            }
        });
        this.props.setState({
            datasAgendadas: datasAgendadasTemp
        });
    }

    UNSAFE_componentWillMount() {
        this.carregaCalendarTimeline();
    }

    carregaCalendarTimeline = () => {
        var array = [];
        var marcacoes = [];
        var id_groups = 0;
        var id_marc = 0;

        this.props.state.itens.forEach(element => {

            for (let i = 0; i < 8; i++) {
                var day = moment(element.DT_PREV_ENTRG, 'DD/MM/YYYY HH:mm:ss').set({hour:11,minute:59,second:59,millisecond:59}).add(-i+1, 'days');
                var vBgColor = 'rgb(255, 117, 117)';
                var vSelectedBgColor = '#FF7575';
                
                if (day.isoWeekday() == 1) {
                    vBgColor = 'rgb(221, 221, 221)';
                    vSelectedBgColor = '#DDDDDD';
                }
                marcacoes.push({
                    id: id_marc,
                    group: id_groups,
                    title: ' ',
                    start_time: moment(element.DT_PREV_ENTRG, 'DD/MM/YYYY HH:mm:ss').set({hour:0,minute:0,second:0,millisecond:0}).add(-i, 'days'),
                    end_time: moment(element.DT_PREV_ENTRG, 'DD/MM/YYYY HH:mm:ss').set({hour:23,minute:59,second:59,millisecond:59}).add(-i, 'days'),
                    canMove: false,
                    canResize: false,
                    canChangeGroup: false,
                    bgColor: vBgColor,
                    selectedBgColor: vSelectedBgColor,
                    tipo: 2
                });
                id_marc++;
            }
            
            this.leitorDatas(element.availableScheduleDatesList).forEach(x => {
                var d_i = moment(x.data, 'DD/MM/YY').set({hour:0,minute:0,second:0,millisecond:0});
                var d_f = moment(x.data, 'DD/MM/YY').set({hour:23,minute:59,second:59,millisecond:59});
                
                var intervaloI = moment(element.DT_PREV_ENTRG, 'DD/MM/YYYY HH:mm:ss')
                    .set({hour:0,minute:0,second:0,millisecond:0})
                    .add(-8, 'days');
                var intervaloF = moment(element.DT_PREV_ENTRG, 'DD/MM/YYYY HH:mm:ss')
                    .set({hour:23,minute:59,second:59,millisecond:59});
                if (moment(x.data, 'DD/MM/YY') > intervaloI && moment(x.data, 'DD/MM/YY') < intervaloF) {
                    marcacoes.push({
                        id: id_marc,
                        group: id_groups,
                        title: ' ',
                        start_time: d_i,
                        end_time: d_f,
                        canMove: false,
                        canResize: false,
                        canChangeGroup: false,
                        //data disponivel
                        bgColor: 'rgb(226,239,217)',
                        selectedBgColor: '#07533E',
                        tipo: 1
                    });
                    id_marc++;
                }
            });

            if (this.leitorDatas(element.availableScheduleDatesList).length == 0) {
                marcacoes.push({
                    id: id_marc,
                    group: id_groups,
                    title: element.scheduleAvailabilityDescription,
                    tip: element.scheduleAvailabilityDescription,
                    start_time: moment(element.DT_PREV_ENTRG, 'DD/MM/YYYY HH:mm:ss').set({hour:0,minute:0,second:0,millisecond:0}).add(-8, 'days'),
                    end_time: moment(element.DT_PREV_ENTRG, 'DD/MM/YYYY HH:mm:ss').set({hour:23,minute:59,second:59,millisecond:59}),
                    canMove: false,
                    canResize: false,
                    canChangeGroup: false,
                    bgColor: 'rgb(255,80,80)',
                    selectedBgColor: '#FF5050',
                    tipo: 3
                });
                id_marc++;
            }

            array.push({
                id: id_groups, 
                title: element.purchaseOrderId.toString(),
                tip: element.purchaseOrderId.toString()
            });
            id_groups++;
        });

        this.setState({
            groups: array,
            items: marcacoes,
            id_marc_global: id_marc
        });
    }

    leitorDatas = (str) => {
        if (str && str.includes("/")) {
            var array = [];
            var bloco = str.split(",");
            bloco.forEach(element => {
                var e = element.split(";");
                if (e[0].includes("/"))
                    var data = e[0];
                else
                    var data = e[1];
                if (!e[0].includes("/"))
                    var id = e[0];
                else
                    var id = e[1];
                array.push({data: data, id: id});
            });
            return array;
        }
        return [];
    }

    itemRenderer = ({ item, timelineContext, itemContext, getItemProps, getResizeProps }) => {
        const { left: leftResizeProps, right: rightResizeProps } = getResizeProps();
        const backgroundColor = itemContext.selected ? item.selectedBgColor : item.bgColor;
        const borderColor = itemContext.resizing ? "red" : item.color;
        return (
          <div
            {...getItemProps({
              style: {
                backgroundColor,
                color: item.color,
                borderColor,
                borderStyle: "hidden",
                borderWidth: "0px !important",
                borderRadius: 0,
                border: "0px",
              },
              onMouseUp: () => {
                var men = "";
                if (item.tipo == 1) {
                    //checa se ja nao tem item agendado naquele grupo
                    var jaExiste = false;
                    this.props.state.datasAgendadas.forEach(element => {
                        if (element.idGroup == item.group)
                            jaExiste = true;
                    });

                    if (jaExiste) {
                        this.props.setState({
                            itemEscolhido: item
                        });
                        men = "Deseja trocar o dia para "+item.start_time.format('DD/MM/YYYY')+"?";
                    } else {
                        this.props.setState({
                            itemEscolhido: item
                        });
                        men = "Deseja marcar para o dia "+item.start_time.format('DD/MM/YYYY')+"?";
                    }
                    
                } else if (item.tipo == 2) {
                    this.props.setState({
                        itemEscolhido: null
                    });
                    men = "Essa data não esta disponível para agendamento!";
                } else if (item.tipo == 4) {
                    this.props.setState({
                        itemEscolhido: item
                    });
                    men = "Você deseja remover esse agendamento?";
                } else {
                    men = item.tip;
                }
                
                this.handleClickOpen(men);
              },
            })}
          >
            {itemContext.useResizeHandle ? <div {...leftResizeProps} /> : null}
    
            <div
              style={{
                height: itemContext.dimensions.height,
                overflow: "hidden",
                paddingLeft: 3,
                textOverflow: "ellipsis",
                border:'none',
                whiteSpace: "nowrap",                                
                border: 'none'
              }}
            >
              {itemContext.title}
            </div>
    
            {itemContext.useResizeHandle ? <div {...rightResizeProps} /> : null}
          </div>
        );
    };

    animateScroll(invert) {
        const width = (invert ? -1 : 1) * parseFloat(this.scrollRef.style.width); // cos curve in both directions
        const duration = 250;

        const startTime = performance.now();
        let lastWidth = 0;
        const animate = () => {
            let normalizedTime = (performance.now() - startTime) / duration;
            if (normalizedTime > 1) {
            // not overanimate
            normalizedTime = 1;
            }

            const calculatedWidth = Math.floor(
            width * 0.5 * (1 + Math.cos(Math.PI * (normalizedTime - 1)))
            );
            this.scrollRef.scrollLeft += calculatedWidth - lastWidth;
            lastWidth = calculatedWidth;

            if (normalizedTime < 1) {
            requestAnimationFrame(animate);
            }
        };
        requestAnimationFrame(animate);
    };

    isDisableButtons(){
        if (this.state.contador == -3) {
            this.state.disableButtons.previous = true;
            this.state.isInteractingWithItemTable = true;
        }else{
            this.state.disableButtons.previous = false;
        }
        if (this.state.contador == +3) {
            this.state.disableButtons.next = true;
            this.state.isInteractingWithItemTable = true;
        }else{
            this.state.disableButtons.next = false;
        }

        this.setState(state => ({
            disableButtons: state.disableButtons,
            visibleTimeStart: state.visibleTimeStart,
            visibleTimeEnd: state.visibleTimeEnd,
            scrolling: state.scrolling,
            isInteractingWithItemTable: state.isInteractingWithItemTable
        }));
    };

    onPrevClick = () => {
        const zoom = this.state.visibleTimeEnd - this.state.visibleTimeStart;
        this.isDisableButtons();
        this.setState(state => ({
            contador: state.contador-1,
            disableButtons: state.disableButtons,
            visibleTimeStart: state.visibleTimeStart - zoom,
            visibleTimeEnd: state.visibleTimeEnd - zoom,
            //used to apply animation effect if scroll is programmatic
            scrolling: false
        }));
        
        
    };

    onNextClick = () => {
        const zoom = this.state.visibleTimeEnd - this.state.visibleTimeStart;
        this.isDisableButtons();
        this.setState(state => ({
            contador: state.contador+1,
            visibleTimeStart: state.visibleTimeStart + zoom,
            visibleTimeEnd: state.visibleTimeEnd + zoom,
            //used to apply animation effect if scroll is programmatic
            scrolling: false
        }));
        };
        
    handleTimeChange = (visibleTimeStart, visibleTimeEnd, updateScrollCanvas) => {
        //implementacao para tentar limitar calendario a 3 meses
        const minTime = moment().add(-3, 'months').valueOf()
        const maxTime = moment().add(3, 'months').valueOf()

        if (visibleTimeStart < minTime && visibleTimeEnd > maxTime) {
            updateScrollCanvas(minTime, maxTime)
        } else if (visibleTimeStart < minTime) {
            updateScrollCanvas(minTime, minTime + (visibleTimeEnd - visibleTimeStart))
        } else if (visibleTimeEnd > maxTime) {
            updateScrollCanvas(maxTime - (visibleTimeEnd - visibleTimeStart), maxTime)
        } else {
            updateScrollCanvas(visibleTimeStart, visibleTimeEnd)
        }
        
        // Prevents the time from changing beyond our selected date.
        this.setState({
            visibleTimeStart,
            visibleTimeEnd,
            scrolling: true
        });
    };

    render() {
        return(
            <div>
                <div 
                    style={{
                        display: 'flex',
                        borderLeft: '1px solid #ddd',
                        borderBottom: '1px solid #ddd',
                        paddingBottom: '3px',
                        paddingTop: '14px'
                    }}
                >
                    <Button         
                        disabled = {this.state.disableButtons.previous}                 
                        color="primary" 
                        onClick={this.onPrevClick}
                        style={{marginRight:'auto',}}
                    >
                         <ChevronLeftIcon />{'Anterior'} 
                    </Button>
                    <Button 
                        disabled = {this.state.disableButtons.next}              
                        color="primary" 
                        onClick={this.onNextClick}
                    >
                        {'Seguinte'} <ChevronRightIcon />
                    </Button>
                </div>
            <div className={"outerTimeline"}>
                
                <Timeline
                    groups={this.state.groups}
                    items={this.state.items}
                    className={'timeline'}
                    scrollRef={el => (this.scrollRef = el)}
                    onTimeChange={this.handleTimeChange}
                    //</div>defaultTimeStart={moment().month(5).year(2019).add(-12, 'day')}
                    //defaultTimeEnd={moment().month(5).year(2019).add(12, 'day')}
                    defaultTimeStart={this.state.defaultTimeStart}
                    defaultTimeEnd={this.state.defaultTimeEnd}
                    visibleTimeStart={this.state.visibleTimeStart}
                    visibleTimeEnd={this.state.visibleTimeEnd}
                    canvasTimeStart= {this.state.defaultTimeStart}
                    canvasTimeEnd={this.state.defaultTimeEnd}
                    sidebarWidth={0}
                    lineHeight={47}
                    minZoom={moment().hour(0).add(12, 'day') - moment().hour(0).add(-12, 'day')}
                    maxZoom={moment().hour(0).add(12, 'day') - moment().hour(0).add(-12, 'day')}
                    /*
                    minZoom={moment().month(5).year(2019).add(12, 'day') - moment().month(5).year(2019).add(-12, 'day')}
                    maxZoom={moment().month(5).year(2019).add(12, 'day') - moment().month(5).year(2019).add(-12, 'day')}
                    */
                    itemRenderer={this.itemRenderer}
                >
                    <TimelineHeaders>
                        <SidebarHeader>
                            {({ getRootProps }) => {
                                return (
                                    <div 
                                        {...getRootProps()} 
                                        style={{
                                            color:'white',
                                            padding: '10px',
                                            display:'none',
                                        }}
                                    >
                                        Pedidos
                                    </div>
                                );
                            }}
                        </SidebarHeader>
                        <DateHeader unit="primaryHeader" height={39} style={{backgroundColor: '#FFFFFF'}}                            
                            intervalRenderer={({ getIntervalProps, intervalContext, }) => {
                                var time = intervalContext.interval.startTime._d.toLocaleString('pt-br', {month:'long'});
                                var fLetter = time.charAt(0).toUpperCase();
                                var ntime = fLetter+time.substr(1,time.length);
                                return (
                                    <div {...getIntervalProps()} className="rct-dateHeader" align="left"> 
                                        {ntime} {" - "} {intervalContext.interval.startTime._d.getFullYear()}
                                    </div>
                                )
                            }}
                        />
                        <DateHeader unit="day" style={{backgroundColor:'white'}}
                            intervalRenderer={({ getIntervalProps, intervalContext, }) => {
                                return <div {...getIntervalProps()} className="rct-dateHeader" align="center"> 
                                    {intervalContext.interval.startTime._d.toLocaleString('pt-br', {weekday:'short'})}
                                </div>
                            }}
                        />
                        <DateHeader />
                    </TimelineHeaders>
                    <TimelineMarkers
                    >
                        <TodayMarker />
                    </TimelineMarkers> 
                </Timeline>               
                <ModalConfirmacao {...this}/>                             
            </div>         
        </div>  
       );
    }
}
